<template>
    <div v-if="notification" class="maintenance-notification">
        <button
            v-if="isDismissed"
            type="button"
            class="maintenance-notification__toggle"
            title="Zobraziť servisnú hlášku"
            @click="open"
        >
            <i class="fas fa-exclamation"></i>
        </button>

        <div v-else class="alert maintenance-notification__box" role="alert">
            <button type="button" class="close maintenance-notification__close" aria-label="Close" @click="dismiss">
                <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="alert-heading maintenance-notification__title">{{ notification.title }}</h4>
            <div class="maintenance-notification__meta">
                <span>{{ notification.started_at_display }}</span>
                <span class="maintenance-notification__updated">
                    <i class="fa fa-sync"></i>
                    {{ notification.updated_at_display }}
                </span>
            </div>
            <div class="maintenance-notification__message">{{ notification.message }}</div>
            <strong>Odhadovaný čas nedostupnosti: {{ notification.estimated_minutes }} min.</strong>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initialNotification: {
            type: Object,
            default: null,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            notification: this.initialNotification,
            dismissedId: this.$cookie.get('maintenance-notification-dismissed-id'),
            interval: null,
        }
    },
    computed: {
        isDismissed() {
            return this.notification && this.dismissedId === this.notification.id
        },
    },
    mounted() {
        this.interval = setInterval(this.fetchNotification, 30000)
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    },
    methods: {
        fetchNotification() {
            // the global axios toggles the loading of the whole page (craftable interceptors, the class .loading on #app
            // covers every .card-block with an overlay), a new instance has the same defaults but not the interceptors,
            // so this background poll does not blink the page
            axios.create().get(this.endpoint).then(response => {
                const notification = response.data.notification
                const previousId = this.notification ? this.notification.id : null

                this.notification = notification

                if (notification && notification.id !== previousId && notification.id !== this.dismissedId) {
                    this.dismissedId = null
                    this.$cookie.delete('maintenance-notification-dismissed-id')
                }
            }, () => {})
        },
        dismiss() {
            if (!this.notification) {
                return
            }

            this.dismissedId = this.notification.id
            this.$cookie.set('maintenance-notification-dismissed-id', this.notification.id, { expires: '30D' })
        },
        open() {
            this.dismissedId = null
            this.$cookie.delete('maintenance-notification-dismissed-id')
        },
    },
}
</script>

<style scoped>
.maintenance-notification {
    bottom: 20px;
    position: fixed;
    right: 20px;
    z-index: 1050;
}

.maintenance-notification__box {
    border-left: 4px solid #f86c6b;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    margin: 0;
    max-width: 460px;
    min-width: 360px;
    padding: 18px 42px 18px 18px;
    background: #fff6f6;
}

.maintenance-notification__title {
    color: #c92a2a;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
}

.maintenance-notification__meta {
    color: #6c757d;
    font-size: 12px;
    margin-bottom: 10px;
}

.maintenance-notification__updated {
    margin-left: 10px;
}

.maintenance-notification__message {
    margin-bottom: 8px;
    white-space: pre-line;
}

.maintenance-notification__close {
    position: absolute;
    right: 12px;
    top: 10px;
}

.maintenance-notification__toggle {
    align-items: center;
    background: #f86c6b;
    border: 1px solid #f86c6b;
    border-radius: 50%;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
    color: #fff;
    cursor: pointer;
    display: flex;
    height: 42px;
    justify-content: center;
    width: 42px;
}

@media (max-width: 575.98px) {
    .maintenance-notification {
        bottom: 12px;
        left: 12px;
        right: 12px;
    }

    .maintenance-notification__box {
        max-width: none;
        min-width: 0;
        width: 100%;
    }

    .maintenance-notification__toggle {
        margin-left: auto;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/MaintenanceNotification.vue